import {
    RECEIVE_QUARTERLY_TAX_RETURN_BOOK,
    RECEIVE_QUARTERLY_TAX_RETURN_PAYMENT_INVOICE,
    RECEIVE_QUARTERLY_TAX_RETURN_PAYMENTS,
    REQUEST_QUARTERLY_TAX_RETURN,
} from '../actions'
import { updateOrAddItemById } from '../helpers'
import { QUARTERLY_TAX_RETURNS } from '../store/action-types'

export default (
    state = {
        fetchSuccessful: null,
        isCreating: null,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case QUARTERLY_TAX_RETURNS.CREATE_QUARTERLY_TAX_RETURN:
            return { ...state, isCreating: true }

        case REQUEST_QUARTERLY_TAX_RETURN:
            return { ...state, shouldFetch: false }

        case QUARTERLY_TAX_RETURNS.RECEIVE_QUARTERLY_TAX_RETURN:
            return { ...state, ...data }

        case RECEIVE_QUARTERLY_TAX_RETURN_BOOK:
            return { ...state, ...data }

        case RECEIVE_QUARTERLY_TAX_RETURN_PAYMENTS:
            return { ...state, ...data }

        case RECEIVE_QUARTERLY_TAX_RETURN_PAYMENT_INVOICE: {
            const { payments } = state

            const { paymentId: id, invoiceDownloadUrl } = data

            return { ...state, payments: updateOrAddItemById(payments, { id, invoiceDownloadUrl }) }
        }

        default:
            return state
    }
}
